import { NgModule } from '@angular/core';
import { NgxPolygonDrawComponent } from './ngx-polygon-draw.component';

@NgModule({
  declarations: [NgxPolygonDrawComponent],
  imports: [
  ],
  exports: [NgxPolygonDrawComponent]
})
export class NgxPolygonDrawModule { }
